<template>
  <DropDown
    :label="control.label"
    :name="control.label"
    optionLabelKey="text"
    :options="getDisplayOptions(control)"
    optionValueKey="value"
    :tooltip="getTooltip()"
    :value="handleDisplayValue(control)"
    @input="handleChangeValue"
  />
</template>

<script>
import DropDown from 'client/components/FormValidation/DropDown.vue';
import DynamicControlsMixin from 'components/DynamicControls/mixins/DynamicControlsMixin';

export default {
  name: 'DynamicControlsDropDown',

  components: {
    DropDown,
  },

  mixins: [
    DynamicControlsMixin,
  ],

  props: {
    value: {
      default: '',
      type: [String, Number],
    },
  },

  methods: {
    getDisplayOptions(control) {
      const { displayOptions, displayType } = control;
      const displayTypeCaps = displayType.toUpperCase();

      if (displayOptions && displayOptions[displayTypeCaps]) {
        return displayOptions[displayTypeCaps];
      }
      return displayOptions;
    },

    getDisplayValue(control) {
      const self = this;
      const options = self.getDisplayOptions(control);
      // eslint-disable-next-line
      const displayValue = options.find((option) => {
        // eslint-disable-next-line eqeqeq
        if (option.value == self.value) return true;
      });
      return displayValue.text;
    },

    handleChangeValue(value) {
      const handler = this.control.handleValueChange || this.handleChange;

      return handler(value);
    },

    handleDisplayValue(control) {
      const handler = control.getDisplayValue || this.getDisplayValue;

      return handler(control);
    },
  },
};
</script>
